import React, { useCallback, useMemo } from 'react';
import { useStore } from 'zustand/react';
import { useTranslations } from '@components/context';
import {
    makeSelectRulesForContext,
    selectAutomationActions,
    selectCanAddAutomation,
} from '@stores/positionAutomation/PositionAutomation.selectors';
import {
    AUTOMATION_CONTEXT_OUTCOME,
    AUTOMATION_CONTEXT_STEP,
} from '../../helper';
import { AutomationRulesList } from '../AutomationRulesList';
import { AddAutomationMenu } from '@components/Automations';
import './index.less';

const AutomationSection = ({
    store,
    contextId,
    isOutcome = false,
    savedStepIds = new Set(),
    isRecruitmentFlowChanged = false,
}) => {
    const { t } = useTranslations();

    const category = isOutcome ? AUTOMATION_CONTEXT_OUTCOME : AUTOMATION_CONTEXT_STEP;

    const selectRules = useMemo(() => makeSelectRulesForContext(contextId, isOutcome), [contextId, isOutcome]);
    const rules = useStore(store, selectRules);
    const canAddAutomation = useStore(store, selectCanAddAutomation);
    const automationActions = useStore(store, selectAutomationActions);
    const setAutomationModal = useStore(store, (s) => s.setAutomationModal);
    const deleteAutomationRule = useStore(store, (s) => s.deleteAutomationRule);
    const openAutomationRule = useStore(store, (s) => s.openAutomationRule);

    const isUnsavedStep = !isOutcome && !savedStepIds.has(String(contextId));
    const isAddAutomationDisabled = isUnsavedStep || isRecruitmentFlowChanged;

    const handleSelectAction = useCallback(
        (action) => {
            setAutomationModal({ category, contextId, selectedAction: action });
        },
        [category, contextId, setAutomationModal],
    );

    return (
        <div className="automations-section">
            <AutomationRulesList
                rules={rules}
                onDeleteRule={deleteAutomationRule}
                onOpenRule={openAutomationRule}
                category={category}
                contextId={contextId}
            />
            {canAddAutomation && (
                <AddAutomationMenu
                    actions={automationActions}
                    onSelect={handleSelectAction}
                    disabled={isAddAutomationDisabled}
                    disabledTooltip={
                        isAddAutomationDisabled ? t('Save to add an automation') : undefined
                    }
                />
            )}
        </div>
    )
};

export default AutomationSection;
